export const ApplicationManagement = (props: any) => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_2008_13592" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="3" y="2" width="19" height="20">
      <path
        d="M17.75 10.3823C19.5449 10.3823 21 8.92725 21 7.13232C21 5.3374 19.5449 3.88232 17.75 3.88232C15.9551 3.88232 14.5 5.3374 14.5 7.13232C14.5 8.92725 15.9551 10.3823 17.75 10.3823Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M17.75 20.8823C19.5449 20.8823 21 19.4272 21 17.6323C21 15.8374 19.5449 14.3823 17.75 14.3823C15.9551 14.3823 14.5 15.8374 14.5 17.6323C14.5 19.4272 15.9551 20.8823 17.75 20.8823Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M7.25 10.3823C9.04493 10.3823 10.5 8.92725 10.5 7.13232C10.5 5.3374 9.04493 3.88232 7.25 3.88232C5.45507 3.88232 4 5.3374 4 7.13232C4 8.92725 5.45507 10.3823 7.25 10.3823Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M7.25 20.8823C9.04493 20.8823 10.5 19.4272 10.5 17.6323C10.5 15.8374 9.04493 14.3823 7.25 14.3823C5.45507 14.3823 4 15.8374 4 17.6323C4 19.4272 5.45507 20.8823 7.25 20.8823Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
    </mask>
    <g mask="url(#mask0_2008_13592)">
      <path d="M0.5 0.382324H24.5V24.3823H0.5V0.382324Z" fill={props.active ? 'white' : '#5C5C5C'} />
    </g>
  </svg>
);
